import { onCLS, onINP, onLCP } from "web-vitals";
import { recordWebVitalMetric } from "./api";

const supportedMetrics = new Set(["LCP", "INP", "CLS"]);

export function shouldReportWebVital(metric) {
  return supportedMetrics.has(metric?.name) && Number.isFinite(Number(metric.value));
}

export function shouldSendWebVitals(env = import.meta.env) {
  if (env.VITE_DISABLE_API === "1") return false;
  if (env.VITE_ENABLE_WEB_VITALS === "1") return true;
  return env.PROD === true || env.PROD === "true";
}

export function classifyViewport(width) {
  const numericWidth = Number(width || 0);
  if (numericWidth < 768) return "mobile";
  if (numericWidth < 1024) return "tablet";
  return "desktop";
}

export function normalizeRoute(pathname) {
  if (/^\/market\/[^/]+$/.test(pathname)) return "/market/:marketId";
  return pathname || "/";
}

export function buildWebVitalPayload({
  metric,
  pathname = globalThis.location?.pathname || globalThis.window?.location?.pathname || "/",
  viewportWidth = globalThis.innerWidth || globalThis.window?.innerWidth || 0,
  connection = getConnection()
}) {
  return {
    metricName: metric.name,
    value: Number(metric.value),
    rating: metric.rating || "unknown",
    metricId: String(metric.id || ""),
    route: normalizeRoute(pathname),
    viewportClass: classifyViewport(viewportWidth),
    effectiveConnectionType: String(connection?.effectiveType || "unknown"),
    saveData: Boolean(connection?.saveData),
    navigationType: metric.navigationType || "unknown"
  };
}

export function reportWebVital(metric, { env = import.meta.env } = {}) {
  if (!shouldReportWebVital(metric)) return;
  if (!shouldSendWebVitals(env)) return;
  const payload = buildWebVitalPayload({ metric });
  recordWebVitalMetric(payload).catch(() => null);
}

export function registerWebVitals() {
  onLCP(reportWebVital);
  onINP(reportWebVital);
  onCLS(reportWebVital);
}

function getConnection() {
  const nav = globalThis.navigator || globalThis.window?.navigator;
  return nav?.connection || nav?.mozConnection || nav?.webkitConnection;
}
